<template>
  <section>
    <v-dialog
      v-model="dialog"
      width="420px">
      <div class="dialog-container">
        <div class="plan-header">
          <div class="info flex">
            <h3>Claim Settle (HD 200)</h3>
            <i
              class="el-icon-close"
              @click="handleCancel"></i>
          </div>
        </div>
        <div class="dialog-body">
          <div class="flex">
            <span>Flight delay date</span>
            <span>{{form.anticipate_date||'-'}}</span>
          </div>
          <div
            class="flex">
            <span>Delayed (mins)</span>
            <span>{{form.delay_min||'-'}} mins</span>
          </div>
          <div
            class="flex">
            <span>Hold Dollars</span>
            <span>200</span>
          </div>
        </div>
        <div class="dialog-footer">
          <v-button @click="handleCancel">Cancel</v-button>
          <div>
            <v-button
              red
              @click="onContinue(2)">Reject</v-button>
            <v-button
              green
              @click="onContinue(1)">Confirm</v-button>
          </div>
        </div>
      </div>

    </v-dialog>
    <send-email-sms
      ref="send-email-sms"
      :form="customer_profile"
      :is-edit="true"
      :initContent="initContent"
      :emailListTitle="emailListTitle"
      :emailTitle="emailTitle"
      @skip="handlerSkip"
      @send="handlerSend" />
  </section>

</template>
<script>
import MixinRules from '@/mixins/rules'
import {claimSettleFlightDelay} from '@/api/flightDelay'
import SendEmailSms from '@/views/components/dialogs/send-email-sms'

export default {
  name: 'ClaimSettleDialog',
  components:{
    SendEmailSms
  },
  mixins: [MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    detailData: {
      type: Object,
      default: () => ({})
    },
    id: {
      type: [String, Number],
      default: ''
    },
    value:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      dialog: false,
      settle_id: '',
    }
  },
  computed:{
    customer_profile(){
      let {mobile_no,lst_nm, fst_nm, contact_nm, isrd_nm} = this.form||{}
      return  {identity:1,mobile_no,isrd_lst_nm:lst_nm, isrd_fst_nm:fst_nm, contact_nm, isrd_nm}||{}
    },
    emailListTitle(){
      let {success_upgraded_list_title}  = this.detailData||{}
      return success_upgraded_list_title
    },
    emailTitle(){
      let {success_upgraded_title}  = this.detailData||{}
      return success_upgraded_title
    },
    initContent(){
      let {send_template}  = this.form||{}
      return send_template
    },
  },
  watch: {
    value:{
      immediate: true,
      handler(val){
        this.dialog = val
      }
    }
  },
  methods: {
    handlerSkip(){
      let params ={
        content:'',
        is_send:0
      }
      this.network().claimSettleFlightDelay(params)
    },
    handlerSend(content){
      let params ={
        content:content,
        is_send:1
      }
      this.network().claimSettleFlightDelay(params)
    },
    handleCancel(){
      this.dialog = false
      this.$emit('input',this.dialog)
    },
    onContinue(settle_id) {
      this.settle_id = settle_id
      if(settle_id==2)
      {
        let params ={
          content:'',
          is_send:0
        }
        this.network().claimSettleFlightDelay(params)
      }else
        this.$refs['send-email-sms'].changeDialog()
      // this.network().claimSettleFlightDelay({settle_id})
    },
    network() {
      return {
        claimSettleFlightDelay: async (params) => {
          let id = this.$route.params.id
          params = {
            id: id,
            num: this.form.num,
            settle_id:this.settle_id,
            ...params
          }

          const { data } = await claimSettleFlightDelay(params)
          this.dialog = false
          this.$emit('input',this.dialog)
          this.$emit('refresh')

        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
  //padding: 15px;
  .plan-header {
    //padding: 15px;
    background: #F6F8FA;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    .info{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding:10px 10px 10px 10px;
      font-size: 14px;
      font-weight: 600;
      color: #24292E;
      i{
        font-weight: 600;
        font-size: 14px;
      }
      h3{
        padding-bottom: 0;
      }
    }
  }
  .dialog-footer {
    //margin: 15px -15px -15px;
    display: flex;
    justify-content: space-between;
    padding: 15px;
    text-align: right;
    background: #F9FAFB;
  }
  .form-item {
    & > span {
      font-weight: bold;
      font-size: 16px;
    }
  }
  .dialog-body{
    padding: 15px;
    .flex{
      margin-bottom: 10px;
      span{
        width: 120px;
        margin-right: 15px;
        color: $dark;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
        &:last-child{
          color:  #6A737D;
          font-weight: 600;
        }
      }
    }

  }
}
</style>
